import {
  isWinner,
  isWinnerInEvent,
  LinkCreationService,
  extractParticipantDisplayScore,
  isDoubles,
  getTeamName,
} from '@sportal365/smp-widget-utils';
import { IConfigEntityLinks } from '../../../types/common';
import { IGroup, INormalizedMultisportPlayoffData, IPlayoffMultisportResponse } from '../../../types/multisport-playoff';
import { TARGET_BLANK, TARGET_SELF } from '../../../constants/windowTarget';
import { FINAL_RESULT, SMALL_FINAL } from '../../../constants/playoff';
import { ACTIVE } from '../../../constants/actitivityStatus';
import format from 'date-fns/format';

function normalizePlayoffKnockoutData(
  apiResponse: IPlayoffMultisportResponse,
  dataEntityLinks: IConfigEntityLinks | undefined,
  dataTeamNameType?: string,
): INormalizedMultisportPlayoffData {
  const rounds = apiResponse?.data?.rounds;
  const linkService = dataEntityLinks && new LinkCreationService(dataEntityLinks);
  const urlTarget = dataEntityLinks?.configuration?.newWindow ? TARGET_BLANK : TARGET_SELF;

  const groups_events: IGroup[][] = rounds?.map((round) => {
    return round?.groups?.map((group) => ({
      ...group,
      participants: group.participants.map((participant) => ({
        ...participant,
        name: getTeamName(participant, dataTeamNameType),
        isWinner: isWinner(participant),
        url: linkService?.createEntityUrl(participant.id, participant.entity_type, participant.type, participant.slug) ?? '#',
        url_target: urlTarget,
        score: extractParticipantDisplayScore(participant.id, group.results),
      })),
      events: group.events.map((event) => {
        return {
          ...event,
          scheduled_start_time: format(new Date(event.scheduled_start_time ?? ''), 'dd.MM'),
          results: event.results
            .filter((result) => result.result_type.type == FINAL_RESULT)
            .map((result) => {
              return {
                ...result,
                participants: result.participants.map((participant) => {
                  const participantDetails = group.participants.find((groupParticipant) => groupParticipant.id === participant.id);
                  return {
                    ...participant,
                    name: participantDetails?.name ?? '',
                    three_letter_code: participantDetails?.three_letter_code ?? '',
                    isWinner: isWinnerInEvent(result.participants, participant),
                  };
                }),
              };
            }),
          url: linkService?.createMatchUrl(event.id, event?.participants?.[0], event?.participants?.[1], event.slug) ?? '#',
          url_target: urlTarget,
        };
      }),
    }));
  });

  return {
    small_final: Object.values(rounds).find((round) => round.name === SMALL_FINAL) || null,
    groups_events,
    round_names: rounds.map((round) => round.name),
    is_doubles: isDoubles(apiResponse?.data?.type),
    active_round: Object.values(rounds).find((round) => round.status === ACTIVE)?.name || '',
  };
}

export default normalizePlayoffKnockoutData;
